import { DialogComponent } from '@theme/dialog';

class ProductLabelsDialog extends DialogComponent {
  requiredRefs = ['dialog', 'title', 'description'];

  /** @type {AbortController | null} */
  #documentClickAbort = null;

  connectedCallback() {
    super.connectedCallback();
    this.#documentClickAbort = new AbortController();
    document.addEventListener('click', this.#handleDocumentClick, {
      capture: true,
      signal: this.#documentClickAbort.signal,
    });
    this.refs.dialog.addEventListener('click', this.#stopModalClickBubbling);
  }

  disconnectedCallback() {
    this.#documentClickAbort?.abort();
    this.#documentClickAbort = null;
    this.refs.dialog?.removeEventListener('click', this.#stopModalClickBubbling);
    super.disconnectedCallback();
  }

  #stopModalClickBubbling = (/** @type {MouseEvent} */ event) => {
    event.stopPropagation();
  };

  /**
   * @param {string} raw
   * @returns {string}
   */
  static #richTextToHtml(raw) {
    if (!raw) return '';
    try {
      const descriptionData = JSON.parse(raw);
      if (descriptionData.type === 'root' && Array.isArray(descriptionData.children)) {
        let htmlContent = '';
        for (const child of descriptionData.children) {
          if (child.type !== 'paragraph' || !Array.isArray(child.children)) continue;
          htmlContent += '<p>';
          for (const textChild of child.children) {
            if (textChild.type === 'text' && typeof textChild.value === 'string') {
              let text = textChild.value.replace(/\n/g, '<br>');
              if (textChild.bold) {
                text = `<strong>${text}</strong>`;
              }
              htmlContent += text;
            } else if (textChild.type === 'link' && textChild.url) {
              const linkText = textChild.children?.[0]?.value ?? '';
              htmlContent += `<a href="${textChild.url}" target="_blank" rel="noopener noreferrer">${linkText}</a>`;
            }
          }
          htmlContent += '</p>';
        }
        return htmlContent;
      }
    } catch {
      // fall through
    }
    return '';
  }

  #handleDocumentClick = (/** @type {MouseEvent} */ event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;

    const trigger = target.closest('.product-labels__label--clickable');
    if (!trigger) return;

    const description = trigger.getAttribute('data-description') ?? '';
    if (!description) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    const labelText = trigger.querySelector('.product-labels__label-text')?.textContent ?? '';
    this.refs.title.textContent = labelText;

    const html = ProductLabelsDialog.#richTextToHtml(description);
    if (html) {
      this.refs.description.innerHTML = html;
    } else {
      this.refs.description.textContent = description;
    }

    this.showDialog();
  };
}

if (!customElements.get('product-labels-dialog')) {
  if (!customElements.get('product-labels-dialog')) customElements.define('product-labels-dialog', ProductLabelsDialog);
}
